import * as React from 'react';

import '@app/scss/components/loading.scss';
import clsx from 'clsx';

export interface LoadingProps {
	small?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({ small }: LoadingProps) => (
	<div className={clsx('lds-ring', small && '_small')}><div /><div /><div /><div /></div>
);
